export interface TrackingMapItem {
  desc: string;
  pageKey: string;
  partKey: string;
}
export const trackMap = new Map<string, TrackingMapItem>([
  [
    '/module/workbench/dashboard',
    {
      desc: '工作台点击数',
      pageKey: 'page_home_nav',
      partKey: 'nav_workbench',
    },
  ],
  [
    '/fle_ai',
    {
      desc: '飞象AI点击数',
      pageKey: 'page_home_nav',
      partKey: 'nav_feixiang_ai',
    },
  ],
  [
    '/module/showroom/mall',
    {
      desc: '万鲤集采点击数',
      pageKey: 'page_home_nav',
      partKey: 'nav_wanli_purchase',
    },
  ],
  [
    '/module/showroom/carpunion/custom/channel',
    {
      desc: '万鲤智造点击数',
      pageKey: 'page_home_nav',
      partKey: 'nav_wanli_mfg',
    },
  ],
  [
    '/module/lgjProduct/home/:homeId',
    {
      desc: '商城 SaaS 点击数',
      pageKey: 'page_home_nav',
      partKey: 'nav_mall_saas',
    },
  ],
  [
    '/module/lgjMall/industrySolutions',
    {
      desc: '项目解决方案点击数',
      pageKey: 'page_home_nav',
      partKey: 'nav_solution',
    },
  ],
  [
    '/module/workbench/account/carpdanceAccount',
    {
      desc: '企业控制台点击数',
      pageKey: 'page_home_nav',
      partKey: 'nav_console',
    },
  ],
  // 工作台二级
  [
    '/module/lgjGoods/goods/list',
    {
      desc: '工作台-商品点击',
      pageKey: 'page_workbench',
      partKey: 'wb_goods',
    },
  ],
  [
    '/webview/lgj/mall/order/list',
    {
      desc: '工作台-订单点击',
      pageKey: 'page_workbench',
      partKey: 'wb_order',
    },
  ],
  [
    '/module/lgjGoods/suppliers/list',
    {
      desc: '工作台-供应商点击',
      pageKey: 'page_workbench',
      partKey: 'wb_supplier',
    },
  ],
  [
    '/webview/lgj/settlement/account',
    {
      desc: '工作台-财务点击',
      pageKey: 'page_workbench',
      partKey: 'wb_finance',
    },
  ],
  [
    '/webview/lgj/data/order',
    {
      desc: '工作台-数据点击',
      pageKey: 'page_workbench',
      partKey: 'wb_data',
    },
  ],
  // 万鲤智造二级
  [
    '/module/showroom/mall',
    {
      desc: '万鲤智造-分类模块点击数',
      pageKey: 'page_wanli_mfg',
      partKey: 'mfg_category_card',
    },
  ],
  // 商城SAAS二级
  [
    '/module/lgjMall/createShop',
    {
      desc: '商城SAAS-创建商城点击',
      pageKey: 'page_mall_saas',
      partKey: 'saas_create_mall_btn',
    },
  ],
  [
    '/module/lgjMall/application',
    {
      desc: '商城SAAS-管理商城点击',
      pageKey: 'page_mall_saas',
      partKey: 'saas_manage_mall_btn',
    },
  ],
  [
    '/module/lgjProduct/operatePage/27',
    {
      desc: '商城SAAS-猫超专区点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_tmall_zone_btn',
    },
  ],
  [
    '/module/lgjProduct/index',
    {
      desc: '商城SAAS-优秀专题点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_topic_card',
    },
  ],
  [
    '/module/lgjProduct/goodsList',
    {
      desc: '商城SAAS-搜货点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_search_btn',
    },
  ],
  [
    '/module/lgjMall/fitmentMall',
    {
      desc: '商城SAAS-橱窗集合点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_window_collection_btn',
    },
  ],
  [
    '/module/lgjMall/shop/template/6',
    {
      desc: '商城SAAS-自选兑换礼包点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_custom_gift_btn',
    },
  ],
  [
    '/module/lgjMall/shop/template/4',
    {
      desc: '商城SAAS-卡券消费商城点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_coupon_mall_btn',
    },
  ],
  [
    '/module/lgjMall/shop/template/3',
    {
      desc: '商城SAAS-员工福利商城点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_welfare_mall_btn',
    },
  ],
  [
    '/module/lgjMall/shop/template/2',
    {
      desc: '商城SAAS-积分营销商城点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_points_mall_btn',
    },
  ],
  [
    '/module/lgjMall/shop/template/1',
    {
      desc: '商城SAAS-商品推广商城点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_promo_goods_mall_btn',
    },
  ],
  [
    '/module/lgjMall/shop/template/5',
    {
      desc: '商城SAAS-企业采购商城点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_b2b_mall_btn',
    },
  ],
  [
    '/module/lgjMall/market/1',
    {
      desc: '商城SAAS-互动营销点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_interaction_marketing_btn',
    },
  ],
  [
    '/module/lgjMall/market/2',
    {
      desc: '商城SAAS-卡券营销点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_coupon_marketing_btn',
    },
  ],
  [
    '/module/lgjMall/market/3',
    {
      desc: '商城SAAS-预算分发点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_budget_assign_btn',
    },
  ],
  [
    '/module/lgjMall/market/4',
    {
      desc: '商城SAAS-促销营销点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_promotion_btn',
    },
  ],
  [
    '/module/lgjMall/market/5',
    {
      desc: '商城SAAS-用户权益点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_user_subsidy_btn',
    },
  ],
  [
    '/module/lgjMall/market/6',
    {
      desc: '商城SAAS-销售渠道点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_sales_channel_btn',
    },
  ],
  [
    '/module/lgjMall/market/7',
    {
      desc: '商城SAAS-个性配置点击数',
      pageKey: 'page_mall_saas',
      partKey: 'saas_custom_config_btn',
    },
  ],
  [
    '/module/lgjProduct/platformSpecial/detail/:detailId',
    {
      desc: '专题-客户浏览量',
      pageKey: 'page_topic_detail',
      partKey: 'topic_view_btn',
    },
  ],
]);
